/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Marker_Import_Error_ToastInputs */

const en_marker_import_error_toast = /** @type {(inputs: Marker_Import_Error_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`An error occurred while importing markers: ${i?.error}`)
};

const fr_marker_import_error_toast = /** @type {(inputs: Marker_Import_Error_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Une erreur est survenue lors de l'importation des marqueurs : ${i?.error}`)
};

const de_marker_import_error_toast = /** @type {(inputs: Marker_Import_Error_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Beim Importieren der Marker ist ein Fehler aufgetreten: ${i?.error}`)
};

const it_marker_import_error_toast = /** @type {(inputs: Marker_Import_Error_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Si è verificato un errore durante l'importazione dei marcatori: ${i?.error}`)
};

const ru_marker_import_error_toast = /** @type {(inputs: Marker_Import_Error_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Произошла ошибка при импорте маркеров: ${i?.error}`)
};

const es_marker_import_error_toast = /** @type {(inputs: Marker_Import_Error_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Se produjo un error al importar marcadores: ${i?.error}`)
};

const zh_cn2_marker_import_error_toast = /** @type {(inputs: Marker_Import_Error_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`导入标记时发生错误：${i?.error}`)
};

const ja_marker_import_error_toast = /** @type {(inputs: Marker_Import_Error_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`マーカーのインポート中にエラーが発生しました: ${i?.error}`)
};

const hi_marker_import_error_toast = /** @type {(inputs: Marker_Import_Error_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`मार्कर आयात करते समय एक त्रुटि हुई: ${i?.error}`)
};

const pt_pt2_marker_import_error_toast = /** @type {(inputs: Marker_Import_Error_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ocorreu um erro ao importar os marcadores: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "An error occurred while importing markers: {error}" |
*
* @param {Marker_Import_Error_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const marker_import_error_toast = /** @type {((inputs: Marker_Import_Error_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marker_Import_Error_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_marker_import_error_toast(inputs)
	if (locale === "de") return de_marker_import_error_toast(inputs)
	if (locale === "it") return it_marker_import_error_toast(inputs)
	if (locale === "ru") return ru_marker_import_error_toast(inputs)
	if (locale === "es") return es_marker_import_error_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_marker_import_error_toast(inputs)
	if (locale === "ja") return ja_marker_import_error_toast(inputs)
	if (locale === "hi") return hi_marker_import_error_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_marker_import_error_toast(inputs)
	return en_marker_import_error_toast(inputs)
});